import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=3d2dd3de&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=3d2dd3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2dd3de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2dd3de')) {
      api.createRecord('3d2dd3de', component.options)
    } else {
      api.reload('3d2dd3de', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=3d2dd3de&scoped=true&", function () {
      api.rerender('3d2dd3de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zk0dtKT87VYg/JS/comp/CookieBox.vue"
export default component.exports